module.exports = "<div class=\"sheet\">\n\t<div *ngIf=\"loginService.logged\" style=\"max-width: 200px;margin:10px auto;background:#ddd;padding:1px;line-height: 40px;text-align: center\" (click)=\"newPost()\">\n\t\t<i class=\"material-icons md-36 icon-black\" style=\"position:relative;top:5px\">add</i> Nova postagem\n\t</div>\n\t<ng-container *ngFor=\"let post of posts\">\n\t\t\t<article1 (remove)=\"onRemove($event)\" *ngIf=\"post.type=='article1'\" [parentPost]=\"post\" [id]=\"post.id\"></article1>\n\t</ng-container>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/posts/posts.component.html
// module id = ./src/app/posts/posts.component.html
// module chunks = main